import React, { useState, useEffect } from "react";
import { IonItem, IonLabel, IonSelect, IonSelectOption } from "@ionic/react";
import "./StartACasePatientList.scss";
import { useTranslation } from "react-i18next";

/**
 * Drop down component
 * Component will show a drop down to select from list.
 * Component will return the selected item id.
 */
interface ListModal {
  patient_id: number;
  patient_name: string;
  added_to_emergency: boolean;
  in_patient: boolean;
}

interface DropDownItemProps {
  ListData: ListModal[];
  getSelectedItem: (value: number) => void;
  enableMultipleSelection?: boolean;
  favCardData?: any;
  value?: any;
  selectedSiteData?: any;
}

const SaCPatientListDropDown: React.FC<DropDownItemProps> = (props) => {
  var [typeId, setTypeId]: any = useState(props.selectedSiteData);
  const { t } = useTranslation("statusBoard");
  useEffect(() => {
    if (props.selectedSiteData) {
      setSelectedCaseType();
    }
  }, [props.ListData]);

  const setSelectedCaseType = () => {
    setTimeout(() => {
      props.getSelectedItem(props.selectedSiteData);
      setTypeId(props.selectedSiteData);
    }, 100);
  };

  const getSelectedValue = (selectedType: any) => {
    if (selectedType === "Other") {
      getSelectedValue(0);
    }
  };

  return (
    <IonItem className="case-types-dropdown">
      <IonSelect
        okText="Done"
        cancelText={t("cancel")}
        value={typeId}
        onIonChange={(e) => {
          setTypeId(e.detail.value);
          getSelectedValue(e.detail.value);
          props.getSelectedItem(e.detail.value);
        }}
        placeholder="Select patient"
        multiple={props.enableMultipleSelection ? true : false}
      >
        <IonLabel>Select patient</IonLabel>

        {props.ListData.map((item) => (
          <IonSelectOption value={item.patient_id} key={item.patient_id}>
            {item.patient_name}
          </IonSelectOption>
        ))}
      </IonSelect>
    </IonItem>
  );
};

export default SaCPatientListDropDown;
